<h1 *ngIf='weather' class="texto">CBBA: MIN {{ weather.tempMin }}ºC, MAX {{ weather.tempMax }}ºC</h1>